const RELOAD_KEY = 'lios_mfe_reload_once';

type ErrorLike = {
  message?: string;
  reason?: unknown;
  error?: unknown;
};

function toErrorMessage(input: unknown): string {
  if (!input) {
    return '';
  }

  if (typeof input === 'string') {
    return input.toLowerCase();
  }

  const candidate = input as ErrorLike;
  const directMessage = String(candidate.message ?? '');
  const nestedReasonMessage = String((candidate.reason as ErrorLike | undefined)?.message ?? candidate.reason ?? '');
  const nestedErrorMessage = String((candidate.error as ErrorLike | undefined)?.message ?? candidate.error ?? '');

  return `${directMessage} ${nestedReasonMessage} ${nestedErrorMessage}`.toLowerCase();
}

function shouldAutoReloadOnError(error: unknown): boolean {
  const message = toErrorMessage(error);
  return (
    message.includes('loading chunk') ||
    message.includes('chunkloaderror') ||
    message.includes('failed to fetch dynamically imported module') ||
    message.includes('importing a module script failed') ||
    message.includes('failed to load module script') ||
    message.includes('expected a javascript-or-wasm module script') ||
    message.includes("mime type of 'text/html'") ||
    message.includes('unexpected token')
  );
}

function forceReloadOnce(): void {
  if (sessionStorage.getItem(RELOAD_KEY) === '1') {
    return;
  }

  sessionStorage.setItem(RELOAD_KEY, '1');
  window.location.replace(`${window.location.pathname}?v=${Date.now()}${window.location.hash || ''}`);
}

function registerRuntimeReloadRecovery(): () => void {
  const onRuntimeError = (event: Event): void => {
    if (shouldAutoReloadOnError(event)) {
      forceReloadOnce();
    }
  };

  const onUnhandledRejection = (event: PromiseRejectionEvent): void => {
    if (shouldAutoReloadOnError(event.reason)) {
      forceReloadOnce();
    }
  };

  window.addEventListener('error', onRuntimeError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);

  return () => {
    window.removeEventListener('error', onRuntimeError);
    window.removeEventListener('unhandledrejection', onUnhandledRejection);
  };
}

const unregisterRuntimeRecovery = registerRuntimeReloadRecovery();
import('./bootstrap')
  .then(() => {
    sessionStorage.removeItem(RELOAD_KEY);
    unregisterRuntimeRecovery();
  })
  .catch((err: unknown) => {
    if (shouldAutoReloadOnError(err)) {
      forceReloadOnce();
      return;
    }

    console.error('Bootstrap failed:', err);
  });
